import React from "react";
import "./Footer.css";
import logo from "../../assets/Logo1.png"; // adjust path as needed

const Footer = ({ onNavigate }) => {
  const currentYear = new Date().getFullYear();
  return (
    <footer className="ai-footer">
      <div className="footer-container">
        <div className="footer-content">
          {/* Left Section */}
          <div className="footer-left">
            <img src={logo} alt="AI Shipshape" className="footer-logo" />

            <div className="footer-contact">
              <p className="footer-label">Address:</p> 110 Hilmanton, Lower
              Earley, Reading, England, RG6 4HJ
              <p className="footer-label">Contact:</p>
              <a href="tel:+44 7590 662656" className="footer-link">
                +44 7590 662656
              </a>
              <a href="mailto:sunny@aishipshape.com" className="footer-link">
                sunny@aishipshape.com
              </a>
            </div>
          </div>

          {/* Right Section */}
          <div className="footer-links">
            <div className="footer-links-wrapper">
              <div className="link-column">
                <p
                  onClick={() => {
                    onNavigate("main");
                    window.scrollTo(0, 0);
                  }}
                >
                  Home
                </p>
                <p
                  onClick={() => {
                    onNavigate("about");
                    window.scrollTo(0, 0);
                  }}
                >
                  About Us
                </p>

                <p
                  onClick={() => {
                    onNavigate("contact");
                    window.scrollTo(0, 0);
                  }}
                >
                  Contact Us
                </p>
              </div>
              <div className="link-column">
                <p className="footer-section-title">Services</p>
                <p
                  onClick={() => {
                    onNavigate("services1");
                    window.scrollTo(0, 0);
                  }}
                >
                  Weather Routing and Voyage Optimization
                </p>
                <p
                  onClick={() => {
                    onNavigate("services2");
                    window.scrollTo(0, 0);
                  }}
                >
                  Vessel Optimization
                </p>
                <p
                  onClick={() => {
                    onNavigate("services3");
                    window.scrollTo(0, 0);
                  }}
                >
                  Carbon Emission Reporting
                </p>
                <p
                  onClick={() => {
                    onNavigate("services4");
                    window.scrollTo(0, 0);
                  }}
                >
                  Shipshape Chat Suite™
                </p>
              </div>
              {/* <div className="link-column">
                <p className="footer-section-title">Upcoming Products</p>
                <p
                  onClick={() => {
                    onNavigate("upcoming1");
                    window.scrollTo(0, 0);
                  }}
                >
                  Shipshape ThrustPower™
                </p>
                <p
                  onClick={() => {
                    onNavigate("upcoming2");
                    window.scrollTo(0, 0);
                  }}
                >
                  Shipshape Engine Performance™
                </p>
                <p
                  onClick={() => {
                    onNavigate("upcoming3");
                    window.scrollTo(0, 0);
                  }}
                >
                  Shipshape Vision Mass Flow Reader™
                </p>
              </div> */}
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-divider" />

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>© {currentYear} AiShipshape. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
